import { GoogleAuthProvider, FacebookAuthProvider } from "firebase/auth";

export const facebookProvider = new FacebookAuthProvider().setCustomParameters({
  prompt: "select_account",
  display: "popup",
});
export const googleProvider = new GoogleAuthProvider().setCustomParameters({
  prompt: "select_account",
});
